module.exports = __webpack_public_path__ + "static/1.2.B.5 CASA MERCEA - PLAN ETAJ-66a5712972bb7845a3cdfa5080608154.jpg";